import React from 'react';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../css/About.css";
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';

export default function About() {
  const [contentFA, setFAContent] = useState(null);
  const [contentEN, setENContent] = useState(null);
  const [consoleError, setConsoleError] = useState("");
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();

  useEffect(() => {
    fetch("/data/about.json")
      .then((res) => res.json())
      .then((data) => (setFAContent(data.FA),setENContent(data.EN)))
      .catch((err) => setConsoleError("Error loading content:", err));
  }, []);

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  if (!contentEN) return <Loading/>;

  return (
    <>
      <NavbarLog />
      <div className="about-page" style={{height:"90vh", marginTop:"25px"}}>
        {setlang==="en"?
        <div className="about-grid-en">
          <h1>{contentEN.h1}</h1>
          <p>{contentEN.p1}</p>

          {contentEN.sections.map((sec, idx) => (
            <div className="about-section" key={idx}>
              <h2>{sec.h2}</h2>
              <p>{sec.p}</p>
            </div>
          ))}
        </div>
        :
        <div className="about-grid-fa">
          <h1>{contentFA.h1}</h1>
          <p>{contentFA.p1}</p>

          {contentFA.sections.map((sec, idx) => (
            <div className="about-section" key={idx}>
              <h2>{sec.h2}</h2>
              <p>{sec.p}</p>
            </div>
          ))}
        </div>
        }
      </div>
      <Footer />
    </>
  );
}